import {
    ReactNode,
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState,
} from 'react'

interface SidebarContextData {
  sidebarIsOpen: boolean
  setSidebarIsOpen: (isOpen: boolean) => void
}

const SidebarContext = createContext<SidebarContextData>(
  {} as SidebarContextData,
)

interface SidebarProviderProps {
  children: ReactNode
}

export function SidebarProvider({ children }: SidebarProviderProps) {
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false)

  const handleSetSidebarIsOpen = useCallback((isOpen: boolean) => {
    setSidebarIsOpen(isOpen)
  }, [])

  const value = useMemo(
    () => ({
      sidebarIsOpen,
      setSidebarIsOpen: handleSetSidebarIsOpen,
    }),
    [sidebarIsOpen, handleSetSidebarIsOpen],
  )

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  )
}

export function useSideBar(): SidebarContextData {
  const context = useContext(SidebarContext)

  if (!context) {
    throw new Error('useSidebar must be used inside a SidebarProvider')
  }

  return context
}
